import { useQuery } from "@tanstack/react-query";
import { IPackagesApi } from "@/api/packages";
import { SERVICES_TYPES, useInjection } from "@/ioc";

export const usePackages = () => {
  const packagesApi = useInjection<IPackagesApi>(SERVICES_TYPES.PACKAGES);

  return useQuery({
    queryKey: ["packages"],
    queryFn: () => packagesApi.getPackages()
  });
};
